import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';
import TextField from '../components/TextField';
import { Row } from "../components/Flex";
import { PrimaryButton, SecondaryButton } from "../components/buttons/Buttons";
import { Package, Tag } from "../typings";
import { fetchPackagesWithoutDrill } from "./drills-api";
import SelectField from "../components/SelectField";
import MultiSelectField from "../components/MultiSelectField";
import { toast } from "react-toastify";
import { ApiContextType } from "../api-context";

interface Props {
    id: number;
    open: boolean;
    api: ApiContextType;
    onClose: () => void;
    onConfirm: (ids: number[]) => void;
}

function AddToPackagesDialog({ id, open, onConfirm, onClose, api }: Props) {
    const [packages, setPackages] = useState<Package[]>([]);
    const [packageIds, setPackageIds] = useState<number[]>([]);

    useEffect(() => {
        if (!open) {
            return;
        }
        fetchPackagesWithoutDrill(api, id)
            .then(packages => {
                setPackages(packages.sort((a,b) => a.name.localeCompare(b.name)));
            })
            .catch(() => {
                toast.error("Failed to fetch packages!");
            });
    }, [id, open, api]);

    const onConfirmAdd = () => {
        setPackageIds([]);
        onConfirm(packageIds);
    };

    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Add file to packages
                    </DialogTitle>
                    <MultiSelectField
                        label="Package"
                        placeholder="Select packages"
                        value={packageIds}
                        options={packages.map(item => ({ value: item.id, text: item.name }))}
                        setValue={setPackageIds}
                    />
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Add" onClick={onConfirmAdd} disabled={false} />
                        <SecondaryButton label="Cancel" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default AddToPackagesDialog;
